import React from 'react';
import { Field, Textarea, Label, Description } from '@headlessui/react';
import clsx from 'clsx';

interface FormTextareaProps {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  error?: string;
  touched?: boolean;
  required?: boolean;
  description?: string;
  placeholder?: string;
  rows?: number;
  className?: string;
}

const FormTextarea: React.FC<FormTextareaProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  error,
  touched,
  required = false,
  description,
  placeholder,
  rows = 4,
  className,
}) => {
  return (
    <Field className={className}>
      <Label className="text-base font-semibold text-slate-700 mb-2 block">
        {label} {required && '*'}
      </Label>
      {description && (
        <Description className="text-sm text-slate-600 mb-2 block leading-relaxed">
          {description}
        </Description>
      )}
      <Textarea
        id={id}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        required={required}
        placeholder={placeholder}
        rows={rows}
        className={clsx(
          'border border-slate-300 block w-full rounded-lg bg-white py-3 px-4 text-base shadow-sm',
          'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
          'transition duration-150 ease-in-out',
          'resize-vertical'
        )}
      />
      {touched && error ? (
        <div className="text-red-700 text-sm mt-2 bg-red-50 border border-red-200 p-2 rounded">
          {error}
        </div>
      ) : null}
    </Field>
  );
};

export default FormTextarea;
